import { createElement } from '@max/max';
import View from '@hfe/max-view';
import { LIST_STATUS } from './types';
import { toPx } from '@max/leez-style-util';
import './index.scss';
import Skeleton from '@hfe/max-skeleton';
// @ts-ignore
import { skData } from './sk.js';
import Sensor from '@max/mbc-sensor';
import { getRenderConfig, renderListContainer } from './render-factory';
import { SHOW_TYPE, STYLE_TYPE } from '../../types/fe';
const NoMoreImageConfig = {
    uri: 'https://p0.meituan.net/ingee/4389c4e1268e625401921d052189d50b8549.png',
    width: toPx(126 / 2),
    height: toPx(27 / 2)
};
function ListContainer(props) {
    var _a;
    const { vo, listStatus, onContainerShow, showType, styleType, listContainerStyle } = props;
    const containerStyle = listContainerStyle !== null && listContainerStyle !== void 0 ? listContainerStyle : {};
    if (showType === SHOW_TYPE.HORIZONTAL && styleType === STYLE_TYPE.COMMON) {
        containerStyle.height = '580rpx';
    }
    // 获取渲染配置
    const renderConfig = getRenderConfig(styleType, showType);
    return <Sensor className="list-container" style={Object.assign({}, containerStyle)} onAppear={() => {
        onContainerShow();
    }} once>
      
      <View x-if={listStatus === LIST_STATUS.LOADING && showType === SHOW_TYPE.VERTICAL_DOUBLE} className="list-container--loading">
        <Skeleton height={'1700rpx'} width={'750rpx'} data={skData}/>
      </View>
      <View x-if={listStatus === LIST_STATUS.SUCCESS && ((_a = vo === null || vo === void 0 ? void 0 : vo.list) === null || _a === void 0 ? void 0 : _a.length) > 0} className="list-container--success">
        {renderListContainer(props, renderConfig)}
      </View>
    </Sensor>;
}
export default ListContainer;
